// Ported from src/shared/api/http_header.js — the gateway expects Bearer auth plus the
// per-request nonce and active-client headers.
export const httpHeader = (token, clientId) => ({
  Authorization: `Bearer ${token}`,
  "X-Nonce": Date.now() * 10,
  "X-Client-Id": clientId ?? "",
});
